import * as Store from '../../../weborder/Store';
import { getPalette, getTypography } from './config';

export const getPaletteVars = () => {
  const store = Store.getStoreInstance();
  const state = store?.getState();

  const primaryColor = state ? state.appDesignScheme.Primary : '#171460';

  return getPalette(primaryColor);
};

export const getTypographyVars = (fontName: string) => {
  const fontFamily = [fontName, 'helvetica', 'arial', 'sans-serif'].join(',');

  return getTypography(fontFamily);
};
